export default {
  ipLoginLoading: false,
};
